import { Box } from '@material-ui/core';
import { TableHeaderCell } from '@setvi/shared/components/s-table/styles';
import { tableCheckboxStyle } from '../table/header';

interface RowContainerProps {
  children: React.ReactNode;
  additionalContent?: JSX.Element;
  checkboxFreeSpace?: boolean;
}

export const RowContainer = ({
  checkboxFreeSpace,
  additionalContent,
  children
}: RowContainerProps) =>
  additionalContent ? (
    <Box display="flex" flexDirection="column" width="100%">
      <Box display="flex" width="100%" alignItems="center">
        {children}
      </Box>
      <Box display="flex" width="100%" alignItems="center">
        {checkboxFreeSpace && <TableHeaderCell style={tableCheckboxStyle} />}
        {additionalContent}
      </Box>
    </Box>
  ) : (
    <>{children}</>
  );
